import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://backend.ems.hiradentallab.com/api/', // Your backend base URL
});

// Add a request interceptor to include the access token in headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance; // Export the configured i